<template lang="pug">
el-form(label-width="130px")
  el-row(v-for="(vv2, index2) in displayFieldLines" :key="index2")
    el-col(:span="vv3.width" v-for="(vv3, index3) in vv2" :key="index3")
      el-form-item(:label="fgetNameAlias(vv3)" :required="vv3.required")
        template(v-if="vv3.expenseItem")
          el-input-number(
            disabled
            :controls="false"
            :precision="2"
            style="width:100%;"
            :min="0")
        template(v-else-if="vv3.daysItem")
          el-input(disabled)
        template(v-else)
          el-input(disabled)
</template>
<script>
import { fgetNameAlias } from '@/ASysUtil/sysFormUtil.js'
export default {
  props: {
    formFieldConfigs: {
      type: Array,
      required: true,
    },
  },
  computed: {
    displayFieldList() {
      return this.formFieldConfigs.filter(vv1 => vv1.display)
    },
    displayFieldLines() {
      const rsList = []
      let tempRow
      this.displayFieldList.forEach((vv1, index1) => {
        if (index1 === 0 || vv1.lineFeed) {
          tempRow = [vv1]
          rsList.push(tempRow)
        } else {
          tempRow.push(vv1)
        }
      })
      return rsList
    },
  },
  methods: {
    fgetNameAlias,
  },
}
</script>
